<template>
  <div v-if="
  this.enableAccessAuthCreate('M7', this.getUser.pref.select.cauth) === true">
    <v-btn :class="ui.textSubheading" v-if="this.data.btnSize === 'flat'"
    flat @click="openDialog()">
      <v-icon left :color="ui.btnColor"> add </v-icon>
      {{this.data.btnTitle}}
    </v-btn>
    <v-btn :class="ui.textSubheading" v-else
    icon @click="openDialog()">
      <v-icon :color="ui.btnColor"> work_outline </v-icon>
    </v-btn>
    <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogLarge">
      <v-card :color="ui.bkgdColor" :text-color="ui.bkgdColor">
        <v-card-title class="title wplblue0--text">
          New Call - {{this.getDetailChar.theme}}
        </v-card-title>
        <v-progress-linear color="blue-grey" height="1" value="100">
        </v-progress-linear>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-container>
            <v-layout row :class="ui.textSubheading">
              <div class="ml-4 mt-4 mb-2">
                Maintenance Call Info
              </div>
            </v-layout>
            <v-layout row class="mr-2">
              <v-spacer/>
              <v-chip :color="ui.chipColor" :text-color="ui.textColor">
                <v-icon left :color="ui.btnColor"> emoji_transportation </v-icon>
                  <div :class="ui.textSubheadingBold">
                    {{this.getDetailRelps.a1.length}}
                  </div>
              </v-chip>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> priority_high </v-icon>
                </v-avatar>
                {{this.getDetailChar.pri}}
              </v-chip>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold"
              v-if="this.getDetailChar.comp !== '' && this.getDetailChar.comp !== 'NA'">
                <v-avatar>
                  <v-icon>assured_workload</v-icon>
                </v-avatar>
                {{this.getDetailChar.comp}}
              </v-chip>
            </v-layout>
            <v-layout row class="mr-2">
              <v-flex xs11>
                <v-text-field
                v-model="localForm.title"
                label="maintenance call name"
                :rules="ruleMustBeFilledANDLessThan50"
                prepend-icon="title"
                required
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row class="mr-2">
              <v-flex xs11>
                <v-text-field
                v-model="localForm.id"
                label="maintenance call id"
                :rules="ruleMustBeFilledANDLessThan50"
                prepend-icon="fingerprint"
                required
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row :class="ui.textSubheading">
              <div class="ml-4 mt-4 mb-2">
                Maintenance Call Requirements
              </div>
            </v-layout>
            <v-layout row class="mr-2">
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> list_alt </v-icon>
                </v-avatar>
                {{this.getTasksList.length}}
              </v-chip>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> person </v-icon>
                </v-avatar>
                {{this.getResourcesList.length}}
              </v-chip>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> category </v-icon>
                </v-avatar>
                {{this.getPartsList.length}}
              </v-chip>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> article </v-icon>
                </v-avatar>
                {{this.getPermitsList.length}}
              </v-chip>
            </v-layout>

            <v-layout row class="ml-2 mr-2">
              <v-flex xs12>
                <v-textarea
                v-model="localForm.call"
                :disabled="false"
                :outline="true"
                required
                :rules="ruleMustBeNotUndefinedANDLessThan1000"
                hint="work call scope"
                auto-grow
                persistent-hint
                ></v-textarea>
              </v-flex>
            </v-layout>
            <v-layout row :class="ui.textSubheading">
              <div class="ml-4 mt-2 mb-2">
                Maintenance Call Dates
              </div>
            </v-layout>
            <v-layout row class="mr-2">
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> grid_view </v-icon>
                </v-avatar>
                {{this.getDetailChar.type}}
              </v-chip>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> filter_list </v-icon>
                </v-avatar>
                {{this.getDetail.char.status}}
              </v-chip>
            </v-layout>
            <v-layout row class="ml-4 mr-2">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> event </v-icon>
                </v-avatar>
                Call Due Date
              </v-chip>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                {{dateTypeA(this.calcDateDueNext(this.getDetail.strategy.char.freq, this.getDetail.strategy.char.unit, this.getDetailStats.dcall, 1.0))}}
              </v-chip>
            </v-layout>
            <v-layout row class="ml-4 mr-2">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> restore </v-icon>
                </v-avatar>
                Last Due Date
              </v-chip>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                {{dateTypeA(this.getDetailStats.dcall)}}
              </v-chip>
            </v-layout>
            <!-- <v-layout row class="ml-4 mr-2">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> event_available </v-icon>
                </v-avatar>
                Next Due Date
              </v-chip>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                {{dateTypeA(this.calcDateDueNext(this.getDetail.strategy.char.freq, this.getDetail.strategy.char.unit, this.getDetailStats.ddue, 2.0))}}
              </v-chip>
            </v-layout> -->
            <v-layout row wrap class="mr-2 mt-4">
              <v-flex xs5 offset-xs2>
                <v-text-field
                :label="this.calcTotalEstimateCost(this.getResourcesList, this.getPartsList, this.getAssetRegister.length)"
                prepend-icon="attach_money"
                hint="plan cost"
                persistent-hint
                readonly
                outline
                ></v-text-field>
              </v-flex>
              <v-flex xs5>
                <v-text-field
                :label="this.calcPartsListCarbon(this.getPartsList, this.getAssetRegister.length)"
                prepend-icon="co2"
                hint="carbon cost"
                persistent-hint
                readonly
                outline
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row class="mr-2">
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> warning </v-icon>
                </v-avatar>
                Maint. Call will generate Work Calls.
              </v-chip>
              <v-spacer/>
            </v-layout>
          </v-container>
        </v-form>
        <v-layout row>
          <v-btn @click="closeDialog()" color="wplblue0" flat>
            <v-icon left> exit_to_app </v-icon>
            Close
          </v-btn>
          <v-spacer/>
          <v-btn @click="validate" color="wplblue0" flat
          :disabled="this.getAssetRegister.length === 0"
          >
            <v-icon left> add </v-icon>
            Work Call
          </v-btn>
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import rulesTextfield from "@/data/rules/mixins/rulesTextfield.js";
import master from "@/data/forms/mixins/master.js";
import listFunctions from "@/data/functions/mixins/listFunctions.js";
import generateForms from "@/data/functions/mixins/generateForms.js";
import techOptions from "@/data/options/mixins/techOptions.js";
import callOptions from "@/data/options/mixins/callOptions.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import generateID from "@/data/cloud/firebase/mixins/generateID.js";
import financeFunctions from "@/data/functions/mixins/financeFunctions.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import callFunctions from "@/data/functions/mixins/callFunctions.js";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import changeDetail from "@/support/detail/mixins/changeDetail.js";
import createFirebase from "@/data/cloud/firebase/mixins/createFirebase.js";
import moment from "moment";

export default {
  // eslint-disable-next-line
  mixins: [
    techOptions,
    dateFunctions,
    listFunctions,
    generateForms,
    callFunctions,
    financeFunctions,
    master,
    callOptions,
    rulesTextfield,
    apptheme,
    generateID,
    numberFunctions,
    docRevsModFunctions,
    changeDetail,
    createFirebase
  ],
  callputed: {
    // eslint-disable-next-line
    ...mapGetters([
      "getDetailStats",
      "getDetailChar",
      "getDetail",
      "getCurrentPage",
      "getAssetRegister",
      "getHazardRegister",
      "getDetail",
      "getUser",
      "getResultsList",
      "getTasksList",
      "getResourcesList",
      "getPartsList",
      "getPermitsList"
    ]),
    enableNewCall() {
      let logic = null;
      if (this.getAssetRegister.length > 0) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    }
  },
  props: {
    data: {
      type: Object
    }
  },
  data() {
    return {
      dialog: false,
      valid: false,
      enableSpinner: false,
      ctr: 0,
      attachLast: null,
      attachListLocal: [],
      localForm: {
        id: "", // maintCalls Id
        title: "", // maintCalls title
        dis: "", // eng. discipline
        call: "", // maintCall callments
        rate: "",
        per: "", // person
        hrs: "", // hours
        type: "" // type
      }
    };
  },
  methods: {
    closeDialog() {
      this.dialog = false;
    },
    openDialog() {
      this.dialog = true;
      // MAINT CALL ID
      let id = this.generateIDMaintCall(
        this.getDetailBasic.tag,
        this.getDetailBasic.idg,
        this.getDetailStats.nm7
      );
      this.localForm.id = id;
      // MAINT CALL ID
      let ctr = this.getDetailStats.nm7 + 1;
      let title = this.getDetail.basic.title;
      title = title + " " + ctr;
      this.localForm.title = title;
      // MAINT CALL SCOPE
      this.localForm.call = this.getDetailChar.call;
    },
    validate() {
      // cosole.log(this.taskForm)
      // this.$refs.form.validate() === true
      if (this.$refs.form.validate() === true) {
        // NEW PART
        let temp = this.generateMaintCallForm();

        const did = this.generateDID("DATE", tag);
        const idg = this.generateIDG("date-gid");
        const tag = "M7";

        // CHECK CTR
        console.log("CONTROL");
        console.log(this.getDetailStats.nm7 + 1);

        // BASIC
        temp.basic.act = true;
        temp.basic.idg = idg;
        temp.basic.did = did;
        temp.basic.tag = tag;
        temp.basic.idi = this.getDetailStats.nm7 + 1;
        temp.basic.title = this.localForm.title;
        temp.basic.id = this.localForm.id;

        // CHAR
        temp.char.type = this.getDetailChar.type;
        temp.char.theme = this.getDetailChar.theme;
        temp.char.pri = this.getDetailChar.pri;
        temp.char.status = this.getDetailChar.status;
        temp.char.call = this.localForm.call;
        temp.char.comp = this.getDetail.strategy.char.comp;
        // eslint-disable-next-line
        temp.char.cost = this.calcTotalEstimateCost(this.getResourcesList, this.getPartsList, this.getAssetRegister.length);
        // eslint-disable-next-line
        temp.char.carb = this.calcPartsListCarbon(this.getPartsList, this.getAssetRegister.length);

        // STATS COUNTERs
        temp.stats.nm7 = this.getDetailStats.nm7;
        temp.stats.na1 = this.getDetailStats.na1;
        temp.stats.ns1 = this.getDetailStats.ns1;
        temp.stats.nh5 = this.getDetailStats.nh5;
        temp.stats.nl5 = this.getDetailStats.nl5;
        temp.stats.no5 = this.getDetailStats.no5;
        temp.stats.nw5 = this.getDetailStats.nw5;
        temp.stats.ne5 = this.getDetailStats.ne5;
        temp.stats.uname = this.getUser.basic.title;
        temp.stats.uemail = this.getUser.basic.email;
        temp.stats.udid = this.getUser.basic.did;

        // STATS DATES
        temp.stats.dcrt = moment().format();
        // let ddue = temp.stats.ddue
        let ddue = this.getDetailStats.ddue;
        let dplan = this.getDetailStats.dplan;
        let freq = this.getDetail.strategy.char.freq;
        let unit = this.getDetail.strategy.char.unit;
        let prep = this.getDetailChar.prep;
        let ddueNew = this.calcDateDueNext(freq, unit, ddue, 1.0);
        temp.stats.ddue = ddueNew;
        temp.stats.dplan = dplan;

        // REV
        temp.rev = this.generateInitialDocumentRev(tag);

        // LINK
        temp.link = this.getDetailLink;
        temp.link.mpdid = this.getDetailBasic.did;
        temp.link.mpid = this.getDetailBasic.id;
        temp.link.mpidg = this.getDetailBasic.idg;
        temp.link.mpt = this.getDetailBasic.title;

        console.log("");
        console.log(">>> GENERATE MAINT CALL <<<");
        console.log("TITLE : " + temp.basic.title);
        console.log(temp);
        console.log(temp.stats.ddue);
        console.log(temp.stats.dplan);

        // GENERATE MAINT CALL THEN WORK CALLS
        // this.createFirebaseMaintCall(temp);
        this.createFirebaseDocumentOnly(temp);

        // UPDATE MAINT PLAN (ORIINAL DOCUMENT)
        let stats = this.getDetailStats;
        stats.nm7 = this.getDetailStats.nm7 + 1;
        // eslint-disable-next-line
        stats.dcall = this.calcDateDueNext(this.getDetail.strategy.char.freq, this.getDetail.strategy.char.unit, this.getDetailStats.dcall, 1.0);
        // NEW DUE DATE -> CURRENT DUE DATE + MAINT PLAN CYCLE
        // stats.ddue = this.calcDateDueNext(freq, unit, ddue, 1.0);
        // eslint-disable-next-line
        stats.ddue = this.calcDateDueNext(this.getDetail.strategy.char.freq, this.getDetail.strategy.char.unit, stats.dcall, 1.0);
        stats.dplan = this.calcDateDueNext(freq, unit, ddueNew, prep);
        this.$store.dispatch("changeDetailStats", stats);
        let char = this.getDetailChar;
        char.last = this.localForm.id;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(5.11, 1); // attachment added.
        this.$store.dispatch("changeDataSavePendingIndication", true);
        // CHANGE DETAIL
        this.changeDetail();

        console.log("");
        console.log("MAINT PLAN STATS UPDATESs");
        console.log("THIS DCALL :" + stats.dcall);
        console.log("NEXT DDUE :" + stats.ddue);
        // console.log("NEXT DPLAN :" + stats.dplan);
        console.log(stats);

        // Close Window
        this.dialog = false;
      }
    }
  }
};
</script>
